<div class="modal__backdrop">
	<gap-card
		data-cy="notification__card"
		gap-elevation="2"
		role="dialog"
		[id]="notify.id"
		[attr.aria-labelledby]="notify.id + '-title'"
		[attr.aria-describedby]="notify.id + '-title'"
		aria-modal="true"
	>
		<gap-card-title data-cy="notification__card--title" *ngIf="notify.title" [id]="notify.id + '-title'">{{ notify.title }}</gap-card-title>
		<gap-card-content
			data-cy="notification__card--message"
			*ngIf="notify.message"
			[id]="notify.id + '-desc'"
		>
			<span [innerHTML]="addLinksToNotification(notify.message)"></span>
			<ahp-dynamic-form
				*ngIf="showInput"
				[controls]="controls"
				[formSubmitted]="closing"
				(formValidityChange)="inputValidity($event)"
			></ahp-dynamic-form>
		</gap-card-content>
		<gap-card-actions id="modalButtons">
			<gap-button
				data-cy="notification__button--cancel"
				[attr.gap-color]="notify.buttonColorCancel || 'secondary'"
				gap-type="text"
				*ngIf="notify.dialogType === 'CONFIRM' && !notify.hideCancelButton"
				id="modal-cancel"
				[attr.aria-controls]="notify.id"
				(click)="closeNotification(clickType.CANCEL)"
			>
				{{ notify.buttonLabelCancel }}
			</gap-button>
			<gap-button
				data-cy="notification__button--ok"
				[attr.gap-color]="notify.buttonColor || 'secondary'"
				[disabled]="(!!notify.inputField && !isInputValid)"
				gap-type="raised"
				id="modal-confirm"
				[attr.aria-controls]="notify.id"
				(click)="closeNotification(clickType.OK)"
			>
				{{ notify.buttonLabel }}
			</gap-button>
		</gap-card-actions>
	</gap-card>
</div>
